import ContentLayout from "../components/layout/ContentLayout";
import { Button, Form, Input, message } from "antd";
import MyModal from "../components/MyModal";
import { useRef, useState } from "react";
import { createReward } from "../actions/acc_actions";

export default function RewardsForm({ businessUrn }) {
  const modalRef = useRef();

  const [reqLoading, setReqLoading] = useState();

  const onFinish = (values) => {
    setReqLoading(true);
    createReward({ businessUrn, data: values })
      .then(() => {
        modalRef.current.showModal();
      })
      .catch(() => {
        message.error("Something went wrong !.");
      })
      .finally(() => setReqLoading(false));
  };

  return (
    <ContentLayout
      header={
        <>
          <h2 className="content_layout-subtitle">Create your stamp reward </h2>
        </>
      }
    >
      <div className="rewards-form-container">
        <Form className="rewards-form" onFinish={onFinish} layout="vertical">
          <div className="rewards-form-section">
            <h4>Reward</h4>
            <div className="rewards-inputs">
              <Form.Item
                name="name"
                label="Reward name"
                rules={[
                  { required: true, message: "Please input reward name!" },
                ]}
              >
                <Input />
              </Form.Item>
              {/* <Form.Item
                name="stamps"
                label="Number of stamps"
                rules={[
                  { required: true, message: "Please input number of stamps!" },
                ]}
              >
                <Input type="number" min={1} />
              </Form.Item>

              <Form.Item
                name="outlet"
                label="Pick an outlet"
                rules={[{ required: true, message: "Please pick an outlet!" }]}
              >
                <Select className="input" placeholder="Select Status">
                  <Option value="active">Active</Option>
                  <Option value="inactive">Inactive</Option>
                </Select>
              </Form.Item>

              <Form.Item name="message" label="Include a message">
                <Input.TextArea
                  style={{ resize: "none" }} // Disable resizing
                  rows={1}
                />
              </Form.Item>*/}
            </div>
          </div>
          {/* <div className="rewards-form-section">
            <h4 style={{ marginTop: 5 }}>Statue</h4>
            <div className="rewards-inputs">
              <Form.Item
                layout="horizontal"
                name="statue"
                label="Active Statue"
              >
                <Switch defaultChecked />
              </Form.Item>
            </div>
          </div> */}
          <Form.Item className="rewards-form-btn">
            <Button type="primary" loading={reqLoading}>
              Create Reward
            </Button>
          </Form.Item>
        </Form>
      </div>

      <MyModal
        ref={modalRef}
        title="Add Reward Successful"
        message="Your Reward Details Has Been Successfully Added and is ready to be added to your Stamp Card."
        imageSrc="/assets/images/modal/star.png"
        confirmText="Back to Rewards"
        navigatePath={-1}
      />
    </ContentLayout>
  );
}
